import * as Yup from 'yup';
import { FILING_STATUS, INITIAL_SOCIAL_SECURITY_BENEFIT, SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT } from '../../../constants';
import { numberWithCommas } from '../../../utils';

const FourthStepSchemaValidator = () => Yup.object().shape({
  benefitEstimator: Yup.object().shape({
    spouseInitialSocialSecurityBenefit: Yup.number()
      .when('filingStatus', {
        is: (filingStatus) => filingStatus === FILING_STATUS.JOINT,
        then: () => Yup.number()
          .min(SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT.MIN, `Select a spouse social security benefit from $${numberWithCommas(SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT.MIN)} to $${numberWithCommas(SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT.MAX)}`)
          .max(SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT.MAX, `Select a spouse social security benefit from $${numberWithCommas(SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT.MIN)} to $${numberWithCommas(SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT.MAX)}`)
          .required('This field is required'),
      }),
    initialSocialSecurityBenefit: Yup.number()
      .min(INITIAL_SOCIAL_SECURITY_BENEFIT.MIN, `Select a social security benefit from $${numberWithCommas(SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT.MIN)} to $${numberWithCommas(SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT.MAX)}`)
      .max(INITIAL_SOCIAL_SECURITY_BENEFIT.MAX, `Select a social security benefit from $${numberWithCommas(SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT.MIN)} to $${numberWithCommas(SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT.MAX)}`)
      .required('This field is required'),
  }),
});

export default FourthStepSchemaValidator;
